import React from 'react';
import map from 'mn-utils/map';
import {
  LINK_APP,
  LINK_CREATE_APP, LINK_CRYPTO_WALLETS, LINK_DEVELOPER_OPTIONS, LINK_EDIT_APP
} from '../../../../constants/links';
import {
  widgets$,
  loadingWidgets$
} from '../../../../emitters/widgets';
import {
  pushLocation,
} from '../../../../router';
import withState from '../../../../utils/withState';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading/B';
import Tooltip from '../../../dumb/Tooltip/B';
import Caption from '../../../dumb/Caption/C';
import Col from '../../../dumb/Col/C';
import MenuForItem from '../../../dumb/Menu/ForItem';

import Button from "../../../dumb/Button/C";

module.exports = withState(() => {
  return (state) => {
    const items = (state.items || []);

    return (
      <div className="mb-70">
        <div className="layoutRow fhaB fvaC">
          <Caption>Developer options</Caption>
          <Button
            className="w170 mv-5 mv10@m"
            // disabled={disabled}
            onClick={() => {
              pushLocation({
                path: LINK_CREATE_APP,
              });
            }}
          >
            New APP
          </Button>
        </div>
        <div className="ovxA mt24">
          {items.length ? (
            <div className="wmin300">
              <div className="bgE layoutRow fhaC fvaC r9 ttU ov ph20 w1/3>1">
                <Col>web site</Col>
                <Col>App ID</Col>
                <Col>API Token</Col>
              </div>
              <WrapperWithLoading
                loading={state.loading}
              >
                <div className="hmax100vh-315 hmin114 bs bcDADCE1 b bb1 ovx ovyA">
                  {map(state.items, (item) => {
                    const {
                      id,
                    } = item;
                    return (
                      <div
                        key={id}
                        className="w layoutRow fhaS fvaC h114 rlv lh fw7 f12 c2 tc lts0em
                        ph20 (ph10|w1/3)>1 bgF6F6F6:even"
                      >
                        <div>
                          <Tooltip>
                            {item.name}
                          </Tooltip>
                        </div>
                        <div>
                          <Tooltip>{id}</Tooltip>
                        </div>
                        <div className="pr15">
                          <Tooltip>{item.api_token}</Tooltip>
                          <MenuForItem items={[
                            {
                              name: 'Details',
                              onClick() {
                                pushLocation({
                                  path: `${LINK_APP}/${id}`,
                                });
                              },
                            },
                            {
                              name: 'Edit application',
                              onClick() {
                                pushLocation({
                                  path: `${LINK_EDIT_APP}/${id}`,
                                });
                              },
                            },
                            {
                              name: 'Wallets list',
                              onClick() {
                                pushLocation({
                                  path: `${LINK_DEVELOPER_OPTIONS}/${id}${LINK_CRYPTO_WALLETS}`,
                                });
                              },
                            },
                            // {
                            //   name: (<div className="cF00">Delete</div>),
                            //   onClick() {
                            //     openPopupDeleteWidget(item, updateWdgets);
                            //   },
                            // },
                          ]}/>
                        </div>
                      </div>
                    );
                  }, [])}
                </div>
              </WrapperWithLoading>
            </div>
          ) : (
            <div>
              Api list is empty. Create the first one.
            </div>
          )}
        </div>
      </div>
    );
  };
}, {
  items: widgets$,
  loading: loadingWidgets$,
});
